// Angular Imports
// =========================================================
import { Component, EventEmitter, ViewChild } from '@angular/core'
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms'
// AG Grid Imports
// =========================================================
import { type ICellRendererAngularComp } from 'ag-grid-angular'
import { type ICellRendererParams } from 'ag-grid-enterprise'
import {
  type Delivery,
  type SubmitRow
} from 'src/app/04_modals/review-orders/reco-buy-qty-submit-modal/reco-buy-qty-submit-modal.component'
// Custom Imports
// =========================================================

@Component({
  standalone: false,
  selector: 'reco-buy-qty-submit-deliveries',
  templateUrl: './reco-buy-qty-submit-deliveries-cell-renderer.component.html',
  styleUrls: ['./reco-buy-qty-submit-deliveries-cell-renderer.component.scss']
})
export class RecoBuyQtySubmitDeliveriesCellRenderer implements ICellRendererAngularComp {
  public params!: ICellRendererParams

  value: string

  propagateFormChange: Function

  formArray = new FormArray([], Validators.required)

  deliveries: Delivery[] = []
  formNames: string[] = ['need_date', 'delivery_type', 'unit_qty']

  row: SubmitRow

  rowHasErrors = false

  init = true

  constructor () {}

  consolelog (s) {
    console.log(s)
  }

  agInit (params: ICellRendererParams): void {
    console.log('delivery cell ag init', this.init)
    this.propagateFormChange = () => {
      params.context.onDeliveryFormChange(this.deliveries, this.rowHasErrors, params.data.row_id)
    }
    this.row = params.data
    this.onAddDelivery()
  }

  onAddDelivery () {
    this.deliveries.push({
      row_id: parseInt(this.row.row_id.split('-')[0]),
      need_date: null,
      delivery_type: null,
      unit_qty: null
    })
    this.formArray.push(
      new FormGroup({
        need_date: new FormControl(null, Validators.required),
        delivery_type: new FormControl(null, Validators.required),
        unit_qty: new FormControl(null, Validators.required)
      })
    )
    this.checkRowValidity()
    this.propagateFormChange()
  }

  onRemoveDelivery (i: number) {
    this.deliveries.splice(i, 1)
    this.formArray.removeAt(i)
    this.checkRowValidity()
    this.propagateFormChange()
  }

  onFormChange (index: number, name: string) {
    console.log('delivery form change', index, name)
    this.deliveries[index][name] = this.formArray.at(index).get(name).value
    this.checkRowValidity()
    this.propagateFormChange()
  }

  checkRowValidity () {
    console.log('checking row validity')
    this.rowHasErrors = false
    if (!this.deliveries.length) {
      this.rowHasErrors = true
    } else {
      for (let i = 0; i < this.deliveries.length; i++) {
        console.log('checking delivery', this.deliveries[i])
        for (let j = 0; j < this.formNames.length; j++) {
          console.log('checking form', this.formNames[j])
          const name = this.formNames[j]
          if (!this.deliveries[i][name]) {
            console.log('found no value in in delivery', i, 'input', name)
            this.rowHasErrors = true
            break
          }
          if (this.formArray.at(i).get(name).errors) {
            console.log('found form error in formGroup', i, 'form', name)
            this.rowHasErrors = true
            break
          }
        }
        if (this.rowHasErrors) break
      }
    }
  }

  refresh (): boolean {
    return true
  }

  destroy () {}
}
